
import React from 'react';

interface IModelContext {
  modelContext: [any, React.Dispatch<any>];
  emptyClearStates?: Record<string, any>; 
}

const ModelContext = React.createContext<IModelContext | undefined>(undefined);

export function ModelProvider(props: {
  model: [any, React.Dispatch<any>];
  emptyClearStates?: Record<string, any>;
  children: React.ReactNode;
}) {
  return (
    <ModelContext.Provider
      value={{
        modelContext: props.model,
        emptyClearStates: props.emptyClearStates
      }}
    >
      {props.children}
    </ModelContext.Provider>
  );
}

export function useModel() {
  const context = React.useContext(ModelContext);
  // sin provider ancestro devuelve undefined en vez de lanzar, para permitir pasar `model` por props
  return context?.modelContext;
}

// Hook para obtener emptyClearStates
export function useEmptyClearFilterModel() {
  const context = React.useContext(ModelContext);
  return context?.emptyClearStates;
}